import { useMutation } from '@libs/use';

import * as API from '../requests';

type UseDeleteFreezeQueryParamsType = {
  onSuccess?: (...arg: any[]) => void;
  onReject?: (...arg: any[]) => void;
};

export default function useDeleteFreezeQuery({
  onSuccess,
  onReject,
}: UseDeleteFreezeQueryParamsType) {
  const {
    execute: deleteFreezeSymbol,
    isPending: isPendingDeleteFreezeSymbol,
    isSuccess: isSuccessDeleteFreezeSymbol,
    ...query
  } = useMutation((requestId: number) => API.deleteFreeze(requestId), {
    onSuccess,
    onReject,
  });

  return {
    deleteFreezeSymbol,
    isPendingDeleteFreezeSymbol,
    isSuccessDeleteFreezeSymbol,
    ...query,
  };
}
